// export const APP_MODE = import.meta.env.MODE; // ["production","development"]

// export const ProjectUrl = "https://api.alpshop.in/";
export const ProjectUrl = "https://alp-be.hkstest.uk/";
// export const ProjectUrl = "https://c70b-223-190-82-250.ngrok-free.app/";
